import { BottoneCopia } from "./BottoneCopia";

export function UserMessage({ text, imageUrl }: { text: string; imageUrl?: string }) {
  return (
    <div className="flex w-full flex-col items-end animate-fade-up">
      <div className="max-w-[85%] whitespace-pre-wrap rounded-2xl rounded-tr-sm bg-gradient-brand px-4 py-2.5 text-[15px] leading-relaxed text-user-bubble-foreground shadow-glow sm:max-w-[75%]">
        {imageUrl && (
          <img
            src={imageUrl}
            alt="Allegato"
            className="mb-1 block h-auto w-auto max-w-full rounded-lg object-contain"
            style={{ maxHeight: 240 }}
          />
        )}
        {text}
      </div>
      {/*
        Si copia anche la propria domanda (Davide, 04/09/2026): serve per
        rilanciarla cambiando una parola, o per incollarla in un rapporto
        accanto alla risposta. Sta FUORI dalla bolla, sotto e allineato a
        destra: dentro avrebbe rubato spazio al testo e sul colore pieno un
        bottone si legge male.
      */}
      {text.trim().length > 0 && (
        <BottoneCopia testo={text} etichetta="Copia la domanda" className="-mt-0.5 -mr-2" />
      )}
    </div>
  );
}
